import { EntitySales } from "../../entity/EntitySales";

export class DtoSalessPostRes extends EntitySales {}
